<template>
  <div v-bind:style="{
    'padding-bottom': !$vuetify.breakpoint.mdAndUp  ? '56px' : 'initial',
  }">
    <list-navigator
      v-bind:style="{
        zIndex: $vuetify.breakpoint.mdAndUp ? 'initial': '10',
      }"
      v-if="detailView"
      backButtonHref="/news"
      :disabled="detailViewData.loading"
      :total="listViewData.items.length"
      :current="currentItemIndex"
      @navigate="(idx) => viewItemDetails(idx)"
    />

    <router-view v-on:request="request" v-bind="viewData" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { ListNavigator } from '@/components';
import NewsListView from './NewsListView.vue';
import NewsDetailView from './NewsDetailView.vue';

// const DETAIL_PATH_REGEX = /\/notifications\/([a-z0-9]+)$/i;
const LIST_PAGE_SIZE = 10;

export {
  NewsListView,
  NewsDetailView,
};

export default {
  components: { ListNavigator },
  data() {
    return {
      newsList: [],
      listViewData: {
        lastSearchArgs: {},
        items: [],
        loading: false,
        isPagination: false,
      },
      detailViewData: {
        item: null,
        backButton: false,
        loading: false,
      },
      currentView: null,
      transitionName: null,
    };
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
    }),
    ...mapState({
      news: ({ news: { news } }) => news,
    }),
    listView() {
      return this.currentView === 'list';
    },
    detailView() {
      return this.currentView === 'detail';
    },
    currentItemIndex() {
      const currentItem = this.detailViewData.item;
      return this.listViewData.items.findIndex((item) => item.id === currentItem.id);
    },
    viewData() {
      let data = {};
      if (this.listView) {
        data = this.listViewData;
      } else if (this.detailView) {
        data = this.detailViewData;
      }
      return data;
    },
  },
  methods: {
    viewItemDetails(idx) {
      const item = this.listViewData.items[idx];
      if (item != null) {
        this.detailViewData.item = item;
        this.$router.push(`/news/${item.id}`);
      }
    },
    async getNewsDetail({ id }) {
      const data = this.detailViewData;
      data.loading = true;

      if (this.listViewData.items.length === 0) {
        await this.getNews();
      }
      const currentList = this.listViewData.items;
      data.backButton = currentList.length > 0;
      try {
        // try to retrieve item from list
        const listItem = currentList.find((li) => li.id === parseInt(id, 10));
        if (listItem != null) {
          data.item = listItem;
        // check if item is currently cached
        } else if (data.item == null || data.item.id !== id) {
          this.$store.dispatch('news/load');
          this.listViewData.items = this.news;

          data.item = this.listViewData.items.find((li) => li.id === parseInt(id, 10));
        }
      } catch (ex) {
        console.error(`error getting news detail (id=${ id })`, ex);
      }

      data.loading = false;
    },
    async getNewsPage() {
      const data = this.listViewData;

      if (data.items.length === 0) {
        data.items = this.news;
      }
      data.loading = true;
      try {
        data.isPagination = this.news.length >= LIST_PAGE_SIZE;
        data.items = this.news;
      } catch (ex) {
        console.error('error getting news page )', ex);
      }
    },
    request({ type, args }) {
      this.currentView = type;
      switch (type) {
      case 'list':
        this.getNewsPage();
        break;
      case 'detail':
        this.getNewsDetail(args);
        break;
      default: console.warn(`some NewsView children requested unmapped data (${type})`);
      }
    },
    async getNews() {
      const id = parseInt(this.$getConst('news.idNews'), 10);
      await this.$store.dispatch('news/load', id);
      this.listViewData.items = this.news;
    },
  },
  async created() {
    this.listViewData.loading = true;
    await this.getNews();
    this.listViewData.loading = false;
  },
};
</script>

<style lang="scss">
  $notifications-navigator-top: 8px;
  $notitications-navigator-right: 40px;

  .notification-card-icon {
    > div {
      border-radius: 50%;
    }
  }

  #notifications-desktop-navigator > .v-toolbar__content {
    width: 100%;
  }

  @media screen and (min-width: 960px) {
    .v-application--is-ltr .v-toolbar__content
    > .v-btn.v-btn--icon:first-child, .v-application--is-ltr .v-toolbar__extension
    > .v-btn.v-btn--icon:first-child {
      margin-left: 0 !important;
    }

    #notifications-desktop-navigator {
      top: $notifications-navigator-top;
      right: $notitications-navigator-right;
    }
  }
</style>
